import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/web.dom-collections.for-each";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import * as Styles from './Styles';
import { ResponsiveMode } from '../models/common';
export function RoundButton(props) {
  var containerCommonStyle = {
    width: 168,
    height: 168,
    borderRadius: '50%',
    border: 'solid 1px rgba(255, 255, 255, 0.9)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    cursor: 'pointer'
  };
  var containerStyle = props.backgroundColor ? _objectSpread(_objectSpread({}, containerCommonStyle), {}, {
    backgroundColor: props.backgroundColor,
    border: ''
  }) : containerCommonStyle;
  var iconStyle = {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  };
  var buttonClassName = 'viewer-common-info-overlay-button' + (props.backgroundColor ? '-filled' : '-transparent');
  return React.createElement("div", {
    className: buttonClassName,
    style: containerStyle,
    onClick: props.onClick
  }, React.createElement("div", {
    className: "viewer-common-info-overlay-button-icon",
    style: iconStyle
  }, props.iconElement));
}
export function SmallButton(props) {
  var containerCommonStyle = {
    width: 199,
    height: 48,
    borderRadius: '5px',
    border: 'solid 1px rgba(255, 255, 255, 0.9)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    cursor: 'pointer'
  };
  var containerStyle = props.backgroundColor ? _objectSpread(_objectSpread({}, containerCommonStyle), {}, {
    backgroundColor: props.backgroundColor,
    border: ''
  }) : containerCommonStyle;
  var iconStyle = {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 24
  };

  var labelStyle = _objectSpread(_objectSpread({}, Styles.mediumTextStyle()), {}, {
    fontSize: 26,
    textAlign: 'center',
    color: 'rgba(255, 255, 255, 1)',
    marginLeft: 18,
    marginRight: 30
  });

  var buttonClassName = 'viewer-common-info-overlay-button-small' + (props.backgroundColor ? '-filled' : '-transparent');
  return React.createElement("div", {
    className: buttonClassName,
    style: containerStyle,
    onClick: props.onClick
  }, React.createElement("div", {
    className: "viewer-common-info-overlay-button-icon-small",
    style: iconStyle
  }, props.iconElement, React.createElement("div", {
    style: labelStyle
  }, props.label)));
}
export function Label(props) {
  var buttonLabelStyle = _objectSpread(_objectSpread({
    marginTop: 24
  }, Styles.boldTextStyle()), {}, {
    fontSize: 25,
    lineHeight: 0.72,
    textAlign: 'center',
    color: 'rgba(255, 255, 255, 1)'
  });

  var loadingLabelStyle = _objectSpread(_objectSpread({}, Styles.mediumTextStyle()), {}, {
    animation: 'fade-in 2s ease-in alternate infinite',
    fontSize: 18,
    letterSpacing: 1.2,
    textAlign: 'center'
  });

  var labelStyle = props.text === 'Loading…' ? loadingLabelStyle : buttonLabelStyle;
  var labelClassName = props.text === 'Loading…' ? 'viewer-common-progress-text' : 'viewer-common-info-overlay-button-label';
  return React.createElement("div", {
    className: labelClassName,
    style: labelStyle
  }, props.text);
}
export function Title(props) {
  var style = _objectSpread(_objectSpread({}, Styles.mediumTextStyle()), {}, {
    fontSize: props.responsiveMode === ResponsiveMode.SMALL ? 24 : 40,
    lineHeight: 1.2,
    letterSpacing: 1,
    marginBottom: props.responsiveMode === ResponsiveMode.SMALL ? 12 : 24,
    marginTop: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  });

  return React.createElement("h1", {
    style: style
  }, props.title);
}